<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-2 p-pb-1">
        <div class="irinox-form" >
          <div class="search-bar p-jc-between  p-text-right p-mb-2">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('admin.users.search')" :aria-label="$t('admin.users.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="display-when-breakpoint">
            <span class="button-header" @click="openAddDialog()"><i class="pi pi-plus" /> {{$t('admin.users.col_adduser')}}</span>
          </div>
          <DataTable :value="users" stripedRows
           v-model:filters="filters" responsiveLayout="stack" breakpoint="960px" 
           selectionMode="single" dataKey="email" @row-click="rowClick">
            <template #empty>
                {{$t('admin.users.empty_list')}}
            </template>
            <template #loading>
                {{$t('admin.users.loading_list')}}
            </template>
            <Column field="firstName" :header="$t('admin.users.col_firstname')" >
              <template #body="slotProps">
                <span v-if="slotProps.data.firstName">{{slotProps.data.firstName}}</span>
                <span v-else class="pending">{{$t('admin.users.pending')}}</span>
              </template>
            </Column>
            <Column field="lastName" :header="$t('admin.users.col_lastname')" ></Column>
            <Column field="email" :header="$t('admin.users.col_email')" ></Column>
            <Column bodyClass="" class="irinox-table-buttons p-text-right">
              <template #header>
                <span class="button-header" @click="openAddDialog()"><i class="pi pi-plus" /> {{$t('admin.users.col_adduser')}}</span>
              </template>
              <template #body="slotProps">
                <div class="button-body">
                  <img src="assets/irinox/icons/share.svg" @click="openAddDialog(slotProps.data.email, slotProps.data.role)" 
                    v-tooltip.left="$t('admin.users.tooltip_share')" :alt="$t('admin.users.tooltip_share')"/>
                  <img src="assets/irinox/icons/delete.svg" @click="openDeleteDialog(slotProps.data.email)" 
                    v-tooltip.left="$t('admin.users.tooltip_delete')" :alt="$t('admin.users.tooltip_delete')"/>
                </div>
              </template>
            
            </Column>
          </DataTable>

        </div>
		</div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="errorDialog" 
    mode="error" 
    :message="$t('admin.users.error_dialog')"
    :life="3000" 
    @update:visible="errorDialog = $event" />
  <IrinoxDialogDark :visible="blockingErrorDialog" 
    mode="error" 
    :message="$t('admin.users.error_dialog')"
    :life="0" 
    @update:visible="blockingErrorDialog = $event" />

  <!--               -->
  <!-- DELETE DIALOG -->
  <!--               -->
  <IrinoxDialogDark :visible="deleteDialog" 
    mode="confirm" 
    :leftB="$t('admin.users.delete_dialog_cancel_button')" 
    @click:left-button="()=>{deleteDialog=!deleteDialog}" 
    :rightB="$t('admin.users.delete_dialog_ok_button')" 
    @click:right-button="deleteUser" 
    :message="$t('admin.users.delete_dialog')"
    icon="assets/irinox/icons/delete_big.svg" />
  <IrinoxDialogDark :visible="successDeleteDialog" 
    mode="success" 
    :message="$t('admin.users.delete_dialog_success')"
    :life="3000" 
    @update:visible="successDeleteDialog = $event" />

  <!--              -->
  <!-- SHARE DIALOG -->
  <!--              -->
  <ShareAppliancesDialog :visible="shareDialog" 
    :preselectedAppliances="selectedAppliances"
    @update:visible="closeShareDialog"
    @click:left-button="closeShareDialog" 
    @click:right-button="closeShareDialog"/>

  <!--            -->
  <!-- ADD DIALOG -->
  <!--            -->
  <ShareDialog :visible="addDialog" 
    mode="user"
    :appliances="selectedAppliances"
    :email="email"
    :role="role"
    @update:visible="addDialog = $event" 
    @click:button="addShare" 
    @click:open-share="openShareDialog"/>
  <IrinoxDialogDark :visible="successAddDialog" 
    mode="success" 
    :message="successAddDialogMessage"
    :life="3000" 
    @update:visible="successAddDialog = $event" />


</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ShareDialog from '../ShareDialog.vue';
import ShareAppliancesDialog from '../ShareAppliancesDialog.vue';
import {FilterMatchMode} from 'primevue/api';

export default {
    components: {
        IrinoxDialogDark,
        ShareDialog,
        ShareAppliancesDialog,
    },
    data() {
        return {
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
          },
          users: [],
          email: null,
          role: null,
          errorDialog: false,
          blockingErrorDialog: false,
          addDialog: false,
          successAddDialog: false,
          successAddDialogMessage: null,
          deleteDialog: false,
          successDeleteDialog: false,
          shareDialog: false,
          selectedAppliances: []
        };
    },
    computed: {
        personaltoken: function() {
            return this.$store.getters['userdata/personaltoken'];
        },
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.reloadUsers();
    },
    methods: {
      reloadUsers() {
        this.applianceService.getAdminUsers(this.personaltoken)
          .then((users) => {
            this.users = users;
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.blockingErrorDialog = true;
          });
      },
      rowClick(event) {
        if(event.originalEvent.target.className == "button-body" ||
            event.originalEvent.target.parentNode.className == "button-body") {
          //SKIP ROW CLICK IF LAST COLUMN
          event.originalEvent.preventDefault();
          return;
        }
        this.$router.push({ name: 'admin-user', params: { email: event.data.email } });
      },
      openAddDialog(email, role) {
        this.email = email;
        this.role = role;
        this.selectedAppliances = [];
        this.addDialog = true;
      },
      openShareDialog() {
        this.addDialog = false;
        this.shareDialog = true;
      },
      closeShareDialog(appliances) {
        if(appliances) {
          this.selectedAppliances = appliances;
        }
        this.shareDialog = false;
        this.addDialog = true;
      },
      addShare(shareData) {

        shareData.appliances = [];
        for (let i = 0; i < this.selectedAppliances.length; i++) {
          shareData.appliances.push(this.selectedAppliances[i].serialNumber);
        }

        this.addDialog = false;

        this.applianceService.postAdminShare(this.personaltoken, shareData)
          .then((data) => {
            if(data.code == "200") {
              if(this.email) {
                this.successAddDialogMessage = this.$t('admin.users.add_dialog_success_edit');
              } else {
                this.successAddDialogMessage = this.$t('admin.users.add_dialog_success');
              }
              this.successAddDialog = true;
              setTimeout(function() {
                this.reloadUsers();
              }.bind(this),3000);
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.errorDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });

      },
      openDeleteDialog(email) {
        this.email = email;
        this.deleteDialog = true;
      },
      deleteUser() {
        this.deleteDialog = false;
        this.applianceService.deleteAdminShare(this.personaltoken, this.email)
          .then((data) => {
            if(data.code == "200") {
              this.successDeleteDialog = true;
              this.users = this.users.filter(function(val) {
                return val.email != this.email;
              }.bind(this));
            } else {
              console.error("ERROR "+JSON.stringify(data));
              this.errorDialog = true;
            }
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.errorDialog = true;
          });
      },
    }
}
</script>

<style>



</style>